import { render, staticRenderFns } from "./wechatMessageList.vue?vue&type=template&id=33af5921"
import script from "./wechatMessageList.vue?vue&type=script&lang=js"
export * from "./wechatMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports